angular.module('SpidApp')

.filter('shiftString', [function () {
   return function (input, nTimes) {
       if (!input || input.length === 0) {
           return ''
       }
       
       if (nTimes === 0 || nTimes === null || nTimes === undefined) {
           return input
       }
       
       var res = input
       for(var i = 0 ; i < nTimes ; i++) {
           res = ' ' + res
       }
       return res
   }
}])
